import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export abstract class ConfigRESTServable {
  abstract getRESTURL(): Observable<string>;
  abstract getRESTGatewayURL(): Observable<string>;
}
